/**
 * Преобразуем переданный quantity:
 * - Если числовое значение больше или равно maxQuantity, то компонент отображает maxQuantity - 1 со знаком "+" после
 * @param {number} quantity - значение "количества" в счётчике
 * @param {number} maxQuantity - максимальное значение счетчика
 */
export const calcQuantity = (quantity: number, maxQuantity: number): string => {
    if (quantity >= maxQuantity && maxQuantity > 1) {
        return `${maxQuantity - 1}+`;
    }
    if (quantity < 0) {
        return "0";
    }

    return quantity.toString();
};
